<template>
    <div @click="openPopup" v-if="pay_sys" class="input_pays flex flex-row cursor-pointer relative w-full mt-2 mb-3 px-2 mb-3 surface-border border-2 border-round-2xl justify-content-left align-items-center overflow-hidden gap-2">
        <div class="flex justify-content-bottom align-items-center">
            <AvatarGroup v-if="pay_sys">
                <Avatar :image="getPaySysImage(pay_sys)" class="w-full surface-0" shape="circle"/>
                <Avatar v-if="pay_sys.bank && pay_sys.bank.image" :image="getPaySysBankImage(pay_sys)" class="w-full surface-0" shape="circle"/>
            </AvatarGroup>
            <Avatar v-else :image="getPaySysImage(pay_sys)" class="w-full surface-0" shape="circle"/>
        </div>
        <div class="flex-1 flex flex-column gap-1 justify-content-center">
            <div class="w-full flex flex-row gap-1 overflow-hidden white-space-nowrap align-items-end font-medium text-sm xl:text-md" >
                <span v-if="getPaySysTitle(pay_sys)" class="">
                    {{ getPaySysTitle(pay_sys) }}
                </span>
                <span v-if="getMaxLimit(pay_sys) && type=='get'" class="text-500">
                    {{ lang('until') }} {{ splitNum(getMaxLimit(pay_sys)) }} {{getCurSign(currency)}} 
                </span>
                <span v-if="getProcessTimer(pay_sys) && type=='send'" class="text-500">
                    {{ lang('until') }} {{ getProcessTimer(pay_sys) }} 
                </span>
            </div>
            <div v-if="!isUserVerified && pay_sys.kyc_required" class="flex">
                <Tag severity="warn" class="text-xs" icon="pi pi-exclamation-triangle">
                    {{ lang('verification_required_title') }}
                </Tag>
            </div>
            <div v-else class="flex font-base text-500 gap-1 text-xs xl:text-md overflow-hidden white-space-nowrap">
                <span v-if="getPaySysDescription(pay_sys)" class="flex">
                    {{ getPaySysDescription(pay_sys) }}
                </span> 
            </div>
        </div>
        <i class="pi pi-chevron-down text-600 absolute right-0 mr-0 surface-50 p-2 border-circle mr-2 deep_white_shadow"></i>
    </div>

    <Dialog v-model:visible="popup" modal
        class="w-full border-round-xl overflow-hidden border-none surface-100"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ headerText }}</span>
        </template>

        <div v-if="list && list.length"
            class="flex flex-column gap-3 xl:py-4 xl:px-1 lg:py-3 md:py-2">
            <MobMenu :headerTxt="getTypeTitle(group)" 
                     :footerTxt="getTypeDescription(group.type)" 
                     v-for="group of list">
                <template v-slot:body>
                    <div v-for="item of group.items" @click="choose(item)"
                        class="w-full relative flex flex-row gap-2 px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:65px">
                        <div class="flex flex-row flex-1 gap-2">
                            <div class="flex align-items-center">
                                <AvatarGroup v-if="item">
                                    <Avatar :image="getPaySysImage(item)" class="w-full surface-0" shape="circle"/>
                                    <Avatar v-if="item.bank && item.bank.image" :image="getPaySysBankImage(item)" class="w-full surface-0" shape="circle"/>
                                </AvatarGroup>
                                <Avatar v-else :image="getPaySysImage(item)" class="w-full surface-0" shape="circle"/>
                            </div>
                            <div class="flex-1 flex flex-column gap-1 justify-content-center">
                               <div class="w-full flex flex-row gap-1 overflow-hidden white-space-nowrap align-items-end font-medium text-sm xl:text-md" >
                                    <span v-if="getPaySysTitle(item)" class="">
                                        {{ getPaySysTitle(item) }}
                                    </span>
                                    <span v-if="getMaxLimit(item) && type=='get'" class="text-500">
                                        {{ lang('until') }} {{ splitNum(getMaxLimit(item)) }} {{getCurSign(currency)}} 
                                    </span>
                                    <span v-if="getProcessTimer(item) && type=='send'" class="text-500">
                                        {{ lang('until') }} {{ getProcessTimer(item) }} 
                                    </span>
                                </div>
                                <div class="flex font-base gap-1 text-500 text-xs xl:text-md overflow-hidden white-space-nowrap">
                                    <span v-if="getPaySysDescription(item)" class="flex">
                                        {{ getPaySysDescription(item) }}
                                    </span>
                                </div>
                                <div v-if="!isUserVerified && item.kyc_required" class="flex">
                                    <Tag severity="warn" class="text-xs" icon="pi pi-exclamation-triangle">
                                        {{ lang('verification_required_title') }}
                                    </Tag>
                                </div>
                            </div>
                        </div>
                        <div class="absolute right-0 top-0 bottom-0 flex justify-content-center align-items-center mr-3">
                            <div class="surface-border border-1 border-circle surface-0 deep_white_shadow">
                                <div class="border-circle" style="width:18px;height:18px;margin:3px" :class="{'bg-green-400': isCurrentPaySys(item), 'surface-0': isCurrentPaySys(item)}"></div>
                            </div>
                        </div>
                    </div>
                </template>
            </MobMenu>
        </div>
    </Dialog>
</template>

<script>
import MobMenu from '@/components/sides/menu/MobMenu.vue'
import Helper from '@/assets/js/Helper.js'

export default {
    name: 'PaymentSysDropdown',
    props: {
        pay_sys: { 
            type: Object, 
            default: null 
        },
        type: { 
            type: String, 
            default: 'get' 
        },
        list: { 
            type: Array, 
            default: () => [] 
        },
        currency: { 
            type: Object, 
            default: null 
        },
        headerText: { 
            type: String, 
            default: '' 
        },
        maxGetLimit: { 
            type: [Number, String], 
            default: null 
        },
        disabled: { 
            type: Boolean, 
            default: false 
        },
    },
    data() {
        return {
            popup: false,
            content: {
                ru: {
                    min: 'мин',
                    hour: 'часа',
                    day: 'дн.'
                },
                en: {
                    min: 'min',
                    hour: 'hour',
                    day: 'day'
                }
            }
        }
    },
    components: {
        MobMenu,
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isUserVerified: function () { return this.$store.getters.StateVerified },
        amountFormat: {
            get() {
                return this.amount;
            },
            set(value) {
                this.$emit('update:amount', value);
            }
        },
    },
    methods: {
        openPopup() {
            if (this.disabled) return;
            this.popup = true;
        },
        getCurSign(cur){
            if(!cur || !cur.sign) return ''
            return cur.sign
        },
        lang(value){ return this.$t(`views.transfer.${value}`)},
        getPaySysImage(item){
            if(item && item.pay_sys && item.pay_sys.image) return item.pay_sys.image
            else return `/images/svg/banks/other.svg`
        },
        getPaySysBankImage(item){
            if(item && item.bank && item.bank.image) return item.bank.image
            else return `/images/svg/banks/other.svg`
        },
        getPaySysTitle(item){
            if(!item) return this.lang('unknown_pay_sys')
            if(item.bank && item.bank.titles && item.bank.titles[this.lang_]) return item.bank.titles[this.lang_]
            if(item.pay_sys && item.pay_sys.titles && item.pay_sys.titles[this.lang_]) return item.pay_sys.titles[this.lang_]
            else return this.lang('unknown_pay_sys')
        },
        getPaySysDescription(item){
            if(!item) return ''
            if(item.bank && item.bank.descriptions && item.bank.descriptions[this.lang_]) return item.bank.descriptions[this.lang_]
            if(item.pay_sys && item.pay_sys.descriptions && item.pay_sys.descriptions[this.lang_]) return item.pay_sys.descriptions[this.lang_]
            if(item.pay_sys && item.pay_sys.titles && item.pay_sys.titles[this.lang_]) return item.pay_sys.titles[this.lang_]
            else return ''
        },
        getProcessTimer(item){
            if(!item || !item.pay_sys || !item.pay_sys.timers) return ''
            const process = item.pay_sys.timers.process
            if(!process || process <=0 ) return ''
            const obj = this.helper.get_minutes_from_seconds(process)
            if(obj.days > 0){
                return `${obj.days} ${this.content[this.lang_].day}`
            } else if(obj.hours > 0){
                return `${obj.hours} ${this.content[this.lang_].hour}`
            } else {
                return `${obj.minutes} ${this.content[this.lang_].min}`
            }
        },
        getTypeTitle(paysys){
            if(!paysys || !paysys.type) return ''
            switch (paysys.type) {
                case 'card': return this.lang('type_card')
                case 'stock': return this.lang('type_stock')
                case 'sbp': return this.lang('type_sbp')
                case 'atm': return this.lang('type_atm')
                case 'swift': return this.lang('type_swift')
                case 'office': return this.lang('type_office')
                case 'crypto': return this.lang('type_crypto')
                case 'courier': return this.lang('type_delivery')
                case 'chat': return this.lang('type_chat')
                case 'qr_nspk': return this.lang('qr_nspk')
                case 'crypto_deposit': return this.lang('crypto_deposit')
                case 'crypto_withdraw': return this.lang('crypto_withdraw')
                case 'internal_topup': return this.lang('internal_wallet')
                case 'internal_withdraw': return this.lang('internal_wallet')
                default: return ''
            }
        },
        getTypeDescription(type) {
            if(!type) return ''
            switch (type) {
                case 'card': return this.lang('type_card_desc')
                case 'stock': return this.lang('type_stock_desc')
                case 'sbp': return this.lang('type_sbp_desc')
                case 'atm': return this.lang('type_atm_desc')
                case 'swift': return this.lang('type_swift_desc')
                case 'office': return this.lang('type_office_desc')
                case 'crypto': return this.lang('type_crypto_desc')
                case 'courier': return this.lang('type_delivery_desc')
                case 'chat': return this.lang('type_chat_desc')
                case 'qr_nspk': return this.lang('qr_nspk_desc')
                case 'crypto_deposit': return this.lang('crypto_deposit_desc')
                case 'crypto_withdraw': return this.lang('crypto_withdraw_desc')
                case 'internal_topup': return this.lang('internal_wallet_topup')
                case 'internal_withdraw': return this.lang('internal_wallet_withdraw')
                default: return ''
            }
        },
        isCurrentPaySys(item){
            if(!item || !this.pay_sys) return false
            return item === this.pay_sys
        },
        choose(item){
            this.$emit('update:pay-sys', item)
            this.popup = false
        },
        splitNum(num){
            return this.helper.split_num(num)
        },
        getMaxLimit(item) {
            // Если есть лимит банка — возвращаем его
            if (item && item.bank && item.bank.limits && item.bank.limits.max && Number(item.bank.limits.max) > 0) {
                return item.bank.limits.max
            }
            // Если есть лимит платежной системы — возвращаем его
            if (item && item.pay_sys && item.pay_sys.limits && item.pay_sys.limits.max && Number(item.pay_sys.limits.max) > 0) {
                return item.pay_sys.limits.max
            }
            // Нет лимитов — возвращаем null
            return null
        },
    },
    beforeCreate() {
        this.helper = new Helper()
    },
}
</script>